<script lang="ts">
    import Segment, { Direction } from "./TimerSegment.svelte";

    export let value = 0;

    let segmentValues = new Array(6).fill(false);
    $: {
        switch(value) {
            case 0:  { segmentValues = [true,  true,  true,  true,  true,  true,  false]; break; }
            case 1:  { segmentValues = [false, true,  true, false, false, false, false]; break; }
            case 2:  { segmentValues = [true, true,  false, true, true, false, true]; break; }
            case 3:  { segmentValues = [true, true,  true, true, false, false, true]; break; }
            case 4:  { segmentValues = [false, true,  true, false, false, true, true]; break; }
            case 5:  { segmentValues = [true, false,  true, true, false, true, true]; break; }
            case 6:  { segmentValues = [true, false,  true, true, true, true, true]; break; }
            case 7:  { segmentValues = [true, true,  true, false, false, false, false]; break; }            
            case 8:  { segmentValues = [true, true,  true, true, true, true, true]; break; }
            case 9:  { segmentValues = [true, true,  true, true, false, true, true]; break; }
            default: { segmentValues = [false, false, false, false, false, false, false]; }
        }
    }

</script>

<Segment posX={20} posY={10} direction={Direction.RIGHT} simValue={segmentValues[0]}></Segment>
<Segment posX={50} posY={10} direction={Direction.DOWN } simValue={segmentValues[1]}></Segment>
<Segment posX={50} posY={40} direction={Direction.DOWN } simValue={segmentValues[2]}></Segment>
<Segment posX={20} posY={70} direction={Direction.RIGHT} simValue={segmentValues[3]}></Segment>
<Segment posX={20} posY={40} direction={Direction.DOWN } simValue={segmentValues[4]}></Segment>
<Segment posX={20} posY={10} direction={Direction.DOWN } simValue={segmentValues[5]}></Segment>
<Segment posX={20} posY={40} direction={Direction.RIGHT} simValue={segmentValues[6]}></Segment>


